import React from "react";
import Heading from "../../../ui/Heading";

const Thanks = () => (
  <div>
    <Heading text={I18n.t("shared.thank_you")} align="center" />
    <p className="text-center">{I18n.t("negotiation_dashboard.cancelation.thank_you.message")}</p>
  </div>
);

export default Thanks;
